import { useState } from 'react'

export interface SuccessSectionProps {
  orderId: string | null
  restaurantName?: string | null
  customerName: string | null
  currency?: string
  whatsappURL?: string | null
  totalPrice: number | null
}

export const useSuccessSection = (props: SuccessSectionProps) => {
  const { orderId, customerName, totalPrice, currency, whatsappURL } = props

  const [isCopied, setIsCopied] = useState(false)

  const formatWhatsAppMessage = () => {
    const message =
      `*New Order Received!*\n\n` +
      `*Order ID:* ${orderId}\n` +
      `*Customer:* ${customerName}\n` +
      `*Total Amount:* ${totalPrice} ${currency}\n\n` +
      `Please confirm my order. Thank you!`

    return encodeURIComponent(message)
  }

  const whatsappLink = `${whatsappURL}?text=${formatWhatsAppMessage()}`

  const handleCopy = () => {
    if (orderId) {
      navigator.clipboard.writeText(orderId)
      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 2000)
    }
  }

  return {
    ...props,
    isCopied,
    whatsappLink,
    handleCopy,
  }
}
